class PfTestimonialMobileCarousel {
	constructor(container) {
		this.container = container;
		this.wrap = this.container.querySelector(".carousel-wrap");
		this.track = this.container.querySelector(".carousel");
		this.group = this.container.querySelector(".carousel__group");
		this.slides = this.group
			? [...this.group.querySelectorAll(".pf-testimonial-carousel__slide")]
			: [];

		this.prevButton = this.container
			.closest(".pf-testimonial-carousel-mobile")
			?.querySelector(".pf-testimonial-carousel__button--prev");

		this.nextButton = this.container
			.closest(".pf-testimonial-carousel-mobile")
			?.querySelector(".pf-testimonial-carousel__button--next");

		this.currentIndex = 0;
		this.totalSlides = this.slides.length;
		this.mobileBreakpoint = 990;

		if (!this.wrap || !this.track || !this.group || !this.slides.length) return;

		this.handleResize = this.handleResize.bind(this);

		this.bindEvents();
		this.update();
	}

	bindEvents() {
		this.prevButton?.addEventListener("click", () => {
			if (window.innerWidth >= this.mobileBreakpoint) return;
			this.goToPrev();
		});

		this.nextButton?.addEventListener("click", () => {
			if (window.innerWidth >= this.mobileBreakpoint) return;
			this.goToNext();
		});

		window.addEventListener("resize", this.handleResize);
	}

	handleResize() {
		if (window.innerWidth >= this.mobileBreakpoint) {
			this.track.style.transform = "";
			return;
		}

		this.update();
	}

	goToPrev() {
		if (this.currentIndex > 0) {
			this.currentIndex -= 1;
		} else {
			this.currentIndex = this.totalSlides - 1;
		}

		this.update();
	}

	goToNext() {
		if (this.currentIndex < this.totalSlides - 1) {
			this.currentIndex += 1;
		} else {
			this.currentIndex = 0;
		}

		this.update();
	}

	update() {
		if (window.innerWidth >= this.mobileBreakpoint) return;

		const slideWidth = this.wrap.offsetWidth;
		const offset = this.currentIndex * slideWidth;

		this.track.style.transform = `translateX(-${offset}px)`;

		if (this.prevButton) {
			this.prevButton.disabled = this.totalSlides <= 1;
		}

		if (this.nextButton) {
			this.nextButton.disabled = this.totalSlides <= 1;
		}
	}
}

function initDesktopMarquees(scope = document) {
	const marquees = scope.querySelectorAll(
		".pf-testimonial-marquee-row .carousel",
	);

	marquees.forEach((track) => {
		const originalGroup = track.querySelector(
			'.carousel__group:not([aria-hidden="true"])',
		);
		if (!originalGroup) return;

		track.style.setProperty(
			"--scroll-distance",
			`${originalGroup.offsetWidth}px`,
		);
	});
}

const mobileCarouselInstances = new WeakMap();

function initMobileCarousel(scope = document) {
	const carousels = scope.querySelectorAll(
		".pf-testimonial-carousel-mobile .pf-testimonial-carousel",
	);

	carousels.forEach((carousel) => {
		if (mobileCarouselInstances.has(carousel)) return;
		const instance = new PfTestimonialMobileCarousel(carousel);
		mobileCarouselInstances.set(carousel, instance);
	});
}

function initPfTestimonials(scope = document) {
	initDesktopMarquees(scope);
	initMobileCarousel(scope);
}

document.addEventListener("DOMContentLoaded", () => {
	initPfTestimonials();
});

document.addEventListener("shopify:section:load", (event) => {
	initPfTestimonials(event.target);
});

window.addEventListener("resize", () => {
	initDesktopMarquees(document);
});